interface ICommentPingSplitService {
  getTextBetweenPingAndStart(commentText: string, pingNumber: number): string;
  getTextBetweenPingAndEnd(commentText: string, pingNumber: number): string;
  getTextBetweenPingAndNextPing(commentText: string, pingNumber: number): string;
}

class CommentPingSplitService implements ICommentPingSplitService {
  getTextBetweenPingAndStart(commentText: string, pingNumber: number): string {
    const split = commentText.split(this.getRegexForPingWithNumber(pingNumber));
    if (split.length < 3) {
      throw Error(`Could not find ping with number ${pingNumber} in comment "${commentText}"`);
    }
    return split[0];
  }

  getTextBetweenPingAndEnd(commentText: string, pingNumber: number): string {
    const split = commentText.split(this.getRegexForPingWithNumber(pingNumber));
    if (split.length < 3) {
      throw Error(`Could not find ping with number ${pingNumber} in comment "${commentText}"`);
    }
    return split[2];
  }

  getTextBetweenPingAndNextPing(commentText: string, pingNumber: number): string {
    const splitByNumberedPing = commentText.split(this.getRegexForPingWithNumber(pingNumber));
    if (splitByNumberedPing.length < 3) {
      throw Error(`Could not find ping with number ${pingNumber} in comment "${commentText}"`);
    }

    const splitByNextPing = splitByNumberedPing[2].split(this.getRegexForAnyPing());

    return splitByNextPing[0];
  }

  // eslint-disable-next-line class-methods-use-this
  getRegexForPingWithNumber(pingNumber: number) {
    return RegExp(`(?=[\\s^]*)([@]${pingNumber})(?=\\s|$)`);
  }

  // eslint-disable-next-line class-methods-use-this
  getRegexForAnyPing() {
    return /(?=[\s^]*)([@]\d+)(?=\s|$)/;
  }
}

export const commentPingSplitService: ICommentPingSplitService = new CommentPingSplitService();
